<script setup>
import axios from 'axios'
import { ref, onMounted } from 'vue'

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
};

const data = ref()

const getData = async() => {
  await axios.get("./php/getLatestComments.php", {
    params: {
      "timestamp" : new Date().getTime()
    }
  }).then((response) => {
    data.value = response.data
  })
}

onMounted(() => {
  getData()
})
</script>

<template>
  <h5>新着コメント</h5>
  <ul>
    <li v-for="comment in data" :key="comment.cid">
      <a :href="comment.url">    
        <div class="css__text-left" style="font-size: .8em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{ comment.thread_title }}</div>
        <div class="css__text-left"
             style="text-overflow: ellipsis;
                    overflow: hidden;
                    line-height: 1.2;
                    max-height: calc(1 * 1.2 * 2rem);
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;">
          {{ comment.content }}
        </div>
        <div class="css__text-right" style="font-size: .8em;">{{ comment.cre_dt }}</div>
      </a>
    </li>
  </ul>
</template>

<style scoped>
  ul {
    list-style: none;
    padding: 1em .2em;
    margin: 0;
  }

  li {
    padding: 0;
    display: inline-block;
    position: relative;
    width: 100%;
    border-bottom: 1px solid rgba(0, 0, 0, .05);
  }

  li a {
    display: block;
    margin: 0;
    padding: 1.25em .75em;
    color: #383c3c;
    text-decoration: none;
  }

  li a:hover {
    transition: .3s;
    background: rgba(0, 0, 0, .05);
  }

  li:first-child {
    border-top: 1px solid rgba(0, 0, 0, .05);
  }

  li span {
    margin-right: .5em;
  }

  li.css__li-child {
    padding-left: 1em;
    border-left: .4em solid rgba(0, 0, 0, .05);
  }
</style>